export const mintTokensTx = `
import FungibleToken from 0x9a0766d93b6608b7
import EmeraldBeta from 0x6c0d53c676256e8c

transaction {

  let RecipientVault: &EmeraldBeta.Vault{FungibleToken.Receiver}

  prepare(acct: AuthAccount) {
      if acct.borrow<&EmeraldBeta.Vault>(from: EmeraldBeta.TokenStoragePath) == nil {
        acct.save(<- EmeraldBeta.createEmptyVault(), to: EmeraldBeta.TokenStoragePath)
        acct.link<&EmeraldBeta.Vault{FungibleToken.Receiver}>(
            EmeraldBeta.TokenPublicReceiverPath,
            target: EmeraldBeta.TokenStoragePath
        )

        acct.link<&EmeraldBeta.Vault{FungibleToken.Balance}>(
            EmeraldBeta.TokenPublicBalancePath,
            target: EmeraldBeta.TokenStoragePath
        )
      }

      self.RecipientVault = getAccount(acct.address).getCapability(EmeraldBeta.TokenPublicReceiverPath)
                              .borrow<&EmeraldBeta.Vault{FungibleToken.Receiver}>()!
  }

  execute {
    EmeraldBeta.mintTokens(recipient: self.RecipientVault)
    log("Minted your EmeraldBeta tokens :)")
  }
}

`